import { useMutation } from '@apollo/client'

import {
  FileToGenerate,
  GenerateSummaryFileDocument,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation GenerateSummaryFile($input: GenerateSummaryFileInput!) {
    generateSummaryFile(input: $input) {
      url
    }
  }
`

export const useGenerateSummaryFile = (): Function => {
  const [mutation] = useMutation(GenerateSummaryFileDocument, {
    client: atlasClient,
  })

  const uploadFileToS3 = async (
    validatedOrdersIdentifier: string,
    fileToGenerate: FileToGenerate,
  ): Promise<object> =>
    await mutation({
      variables: {
        input: {
          validatedOrdersIdentifier,
          fileToGenerate,
        },
      },
    })

  return uploadFileToS3
}
